angular.module('picmonic-common').factory('PromoCodeService', [
  '$q',
  '$stateParams',
  '$cookies',
  'UserService',
  'ReferralDataService',
  'TwentyFourHourDiscountModal',
  'SplitTestService',
  function (
    $q,
    $stateParams,
    $cookies,
    UserService,
    ReferralDataService,
    TwentyFourHourDiscountModal,
    SplitTestService
  ) {
    return {
      getAutoAppliedPromoCode: function (isGroupBuy, overrideCode) {
        promo_code = $q.defer();

        if (overrideCode) {
          promo_code.resolve(overrideCode);
        } else if (isGroupBuy) {
          promo_code.resolve(null);
        } else if ($stateParams.promo_code) {
          promo_code.resolve($stateParams.promo_code);
        } else if (UserService.checkForReferral()) {
          ReferralDataService.promise.then(function () {
            ReferralDataService.referral.affiliate
              ? ReferralDataService.referral.affiliate.affiliate_type === 'Institutional'
                ? promo_code.resolve('schooldiscount')
                : promo_code.resolve('vipdiscount')
              : promo_code.resolve('referral20');
          });
        } else if (UserService.user.user_id && TwentyFourHourDiscountModal.check()) {
          //var split = SplitTestService.split('day_2_promo_code_cta_fixed', ['auto_applied', 'must_click_cta']);
          var split = 'must_click_cta';
          if (
            split === 'auto_applied' ||
            (split === 'must_click_cta' && parseInt($cookies.get('pls_user_day_2_cta_clicked'), 10))
          ) {
            promo_code.resolve('xap1b3kz3ai82');
          } else {
            promo_code.resolve(null);
          }
          //} else if (((UserService.user.user_id && UserService.user.is_trial) || !UserService.user.user_id) && SplitTestService.split('schools_closed_banner_v4', ['a', 'b'], null, true) === 'b') {
          //    promo_code.resolve('onlinesuccess20');
        } else {
          promo_code.resolve(null);
        }

        return promo_code.promise;
      },
    };
  },
]);
